<template>
  <svg aria-hidden="true" role="img" viewBox="0 0 24 24">
    <!-- eslint-disable max-len -->
    <path
      fill="currentColor"
      d="M19 20H6c-3.3 0-6-2.7-6-6c0-3.1 2.3-5.6 5.3-6C6.6 5.6 9.1 4 12 4c3.6 0 6.7 2.6 7.4 6c2.6.2 4.6 2.3 4.6 5s-2.3 5-5 5m-8-5v2h2v-2h-2m0-2h2V7h-2v6Z"
    ></path>
    <!-- eslint-enable max-len -->
  </svg>
</template>
